import { requireNodeEnvVar } from "../../server/utils";

const baseUrl = requireNodeEnvVar("BACKEND_SERVICE_URL");

export const createDataMappingUrl = (fileUrl: string) => {
  const encodedFileUrl = encodeURIComponent(fileUrl);
  return `${baseUrl}/get_source_paths_estimated/?file_uri=${encodedFileUrl}`;
};

export const createTestUrl = (
  fileUrl: string,
  accountId: string,
  userId: string,
  cacheKey: string
) => {
  const encodedFileUrl = encodeURIComponent(fileUrl);
  const encodedCacheKey = encodeURIComponent(cacheKey);
  return `${baseUrl}/test_map?url=${encodedFileUrl}&account_id=${accountId}&user_id=${userId}&cache_key=${encodedCacheKey}`;
};

export const createStartBatchUrl = (fileUrl: string, accountId: string) => {
  return `${baseUrl}/generate_miq_parsed_file/?file_uri=${fileUrl}&account_id=${accountId}`;
};

export const createProcessEnrichedFileUrl = (fileUrl: string) => {
  return `${baseUrl}/process_enriched_file/?file_uri=${fileUrl}`;
}

export const createShopifyToInternalTableUrl = (account_id: string, collection_name: string, shopify_store_name: string) => {
  const encodedCollectionName = encodeURIComponent(collection_name);
  const encodedShopifyStoreName = encodeURIComponent(shopify_store_name);
  return `${baseUrl}/import/shopify_to_internal_table?account_id=${account_id}&collection_name=${encodedCollectionName}&shopify_store_name=${encodedShopifyStoreName}`;
}

export const createJobStatusUrl = (jobId: string) => {
  return `${baseUrl}/jobs/${jobId}`;
}

export const createEnrichingDataUrl = (accountId: string, filePath: string) => {
  const subPath = filePath.replace(/^gs:\/\/[^/]+\//, "");
  return `https://europe-west2-glov-ecomai.cloudfunctions.net/miq/batch/createBatchJob?accountId=${accountId}&productsFilePath=${subPath}`;
};

export const createEnrichingDataStatusUrl = (jobId: string) => {
  return `https://europe-west2-glov-ecomai.cloudfunctions.net/miq/batch/getBatchJobDetails?jobId=${jobId}`;
};

export const createFileUploadUrl = (fileName: string) => {
  return `${baseUrl}/upload_raw_file/?fileName=${fileName}`;
};

export const createTablePreviewUrl = (tableId: string) => {
  return `${baseUrl}/get_preview_from_table/?table_hash=${tableId}&limit=1000&offset=0`;
}

export const shopifyBackendBaseUrl = "https://genmiq-appshp-services-894145150101.europe-west3.run.app/api/shopify";
export const chargebeeBackendBaseUrl = "https://genmiq-appshp-services-894145150101.europe-west3.run.app/api/chargebee";
//export const shopifyBackendBaseUrl = "http://localhost:3009/api/shopify"
//export const chargebeeBackendBaseUrl = "http://localhost:3009/api/chargebee"